import './vibevision-survey.scss'
import 'babel-polyfill'
import 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

store.dispatch('initSurvey')

// Setup survey site app
new Vue({
  store,
  render: h => h(App)
}).$mount('#vibevision-survey')
